import Buttons from '../../elements/modal/genericAcceptModalButtons';
import Container from '../../atoms/container/modalContainer';
import DeviceConfig from '@devices/config';
import Error from '../../atoms/container/errorContainer';
import QrContainer from '../../atoms/container/deviceNotCompatibleModalQrContainer';
import QrGenerator from '../../elements/qr/qrGenerator';
import Subtitle from '../../atoms/text/modalSubtitle';
import SupportUrlText from '../../atoms/text/modalSupportUrlText';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import { useAppDispatch, useAppSelector } from '@shared/store/hooks';
import { adsSelector } from '@shared/store/slices/ads.slice';
import { useEffect, useRef } from 'react';
import { pushFocus } from '@shared/store/slices/focus.slice';
import Focus from '@shared/types/enums/focus';

function DeviceNotCompatibleModal() {
  const { supportUrl } = DeviceConfig.capabilities;
  const dispatch = useAppDispatch();
  const refocus = useRef(false);
  const { videoAd } = useAppSelector(adsSelector);
  useEffect(() => {
    if (videoAd && !refocus.current) {
      refocus.current = true;
    } else if (refocus.current) {
      refocus.current = false;
      dispatch(pushFocus(Focus.MODAL_BUTTONS));
    }
  }, [videoAd]);

  return (
    <Container>
      <Error>
        <Subtitle>
          {TranslationManager.get('MODAL.DEVICE_NOT_COMPATIBLE.BODY')}
          <br></br>
          <br></br>
          {TranslationManager.get('MODAL.DEVICE_NOT_COMPATIBLE.BODY_2')}
        </Subtitle>
        {supportUrl ? (
          <QrContainer>
            <QrGenerator scale={1.4} url={supportUrl} />
          </QrContainer>
        ) : null}
        <Buttons
          acceptButtonText='MODAL.DEVICE_NOT_COMPATIBLE.BUTTONS.CONTINUE'
          cancelButtonText='MODAL.DEVICE_NOT_COMPATIBLE.BUTTONS.EXIT'
          cancelAction={() => DeviceConfig.exit()}
          allowedBack={false}
        />
        {supportUrl ? <SupportUrlText>{supportUrl}</SupportUrlText> : null}
      </Error>
    </Container>
  );
}

export default DeviceNotCompatibleModal;
